import styled from 'styled-components';
import { SCREEN } from '../../../theme/breakpoints';

const Wrapper = styled.div`
  width: 100%;
`;

const isWeb = SCREEN.isWeb;

export const Navigation = styled.div`
  display: flex;
  justify-content: center;
  border-radius: ${isWeb ? 'inherit' : '0px'};
  flex-direction: ${isWeb ? 'inherit' : 'column'};
`;

export const CustomControls = styled.div`
  display: flex;
  justify-content: center;
`;

export default Wrapper;
